import { useQuery } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";

export const useUserPermissionsTenant = (
  personID?: string,
  tenantID?: string
) => {
  const personTenantPermissions = useQuery({
    queryKey: ["personTenantPermissions", personID, tenantID],
    queryFn: () =>
      TenantAPI.getPermissionProfiles(tenantID).then((data) => {
        return data.data.data.profiles.filter((profile: any) =>
          profile.Name.includes("Cloud")
        );
      }),
    enabled: tenantID ? true : false,
  });

  return {
    permissionsFromTenant: personTenantPermissions.data,
    permissionsError: personTenantPermissions.error,
  };
};
